import {Env} from "@morningtrain/helpers";

export default function EnvPlugin(app) {
    app.env = Env;
}
